const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);
const genderLabels = ['<13', '13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'];

export const getPageViewsByGenderData = () =>
  genderLabels.map(x => [
    x,
    {
      male: getRandomNumber(0, 6),
      female: getRandomNumber(0, 6),
    },
  ]);

export const getDataForLabels = (labels, min = 0, max = 5) =>
  labels.map(x => [x, getRandomNumber(min, max)]);



// WEBPACK FOOTER //
// ./src/components/social/facebook/randomDataUtils.js